import { isMobDecisionMob } from './services/mobDecision';

function hasValue(value) {
  return !(value === null || value === undefined || value === '');
}

function isSpeedlineDecisionYes(value: number, allDropdowns?: Record<string, any>) {
  const yesValue = allDropdowns?.speedline_dec?.find(
    (option) => String(option.label).trim().toLowerCase() === 'yes',
  )?.value;
  const isMatchingYes = value == yesValue;
  return isMatchingYes;
}

const speedlineConditionalFields = ['speedline_plant', 'speedline_qty', 'speedline_due'];

export function SetISCellRequired(props) {
  const { field, required, row, allDropdowns } = props;
  const mobOtherValues = [3, 4, 5, 6, 7, 8, 9, 10, 11, 15, 20, 21];

  if (speedlineConditionalFields.includes(field)) {
    return isSpeedlineDecisionYes(row.speedline_dec, allDropdowns);
  }

  switch (field) {
    case 'debitor_name':
    case 'bestellnummer': {
      if (row.saphpocheck === 'POD') {
        return true;
      }
      break;
    }
    case 'npi_comment': {
      if (!row.npi_accept_po && (row.npi_mob === 12 || row.npi_mob === 13)) {
        return true;
      }
      break;
    }
    case 'pag_followup_date': {
      if (row.npi_mob === 14) {
        return true;
      }
      break;
    }
  }

  if (mobOtherValues.includes(row.npi_mob)) {
    return mobOtherValuesMandatory({ row, field, required });
  }

  return required;
}

export function SetIsCellEditable(props) {
  const { field, row, access, allDropdowns } = props;

  if (row?.status === 'D' || !access?.edit_row) {
    return false;
  }

  // Business rule: QSFA stays editable for new rows (even if MoB is prefilled in UI)
  // and becomes read-only only after a persisted MoB decision already exists.
  // QSFA becomes editable when MoB is set to "MoB" or cleared, and read-only when MoB is set to any other value.
  if (
    field === 'qsfaneed' &&
    hasValue(row?.backup?.npi_mob) &&
    !isMobDecisionMob(row?.backup?.npi_mob)
  ) {
    return false;
  }

  if (
    speedlineConditionalFields.includes(field) &&
    !isSpeedlineDecisionYes(row.speedline_dec, allDropdowns)
  ) {
    return false;
  }

  return true;
}

export function mobOtherValuesMandatory(props) {
  const { row, field, required } = props;
  const firstGroup = ['design_owner_id', 'npi_as_kenner', 'novelty_id', 'khk_pkey', 'htz_type_id'];
  const secondGroup = ['debitor_name', 'bestellnummer'];
  const thirdGroup = ['pag_ispartof'];

  const firstGroupValidFieldsList = firstGroup.filter((item) => !row[item]);
  const secondGroupValidConditions =
    row.design_owner_id === 2 && row.project_id != 10 && row.htz_type_id === 4;
  const thirdGroupValidConditions =
    row.design_owner_id === 2 && row.project_id != 10 && row.htz_type_id === 5;

  const checkOne = firstGroup.includes(field) && firstGroupValidFieldsList.length;
  const checkTwo =
    secondGroup.includes(field) && !firstGroupValidFieldsList.length && secondGroupValidConditions;
  const checkThree =
    thirdGroup.includes(field) &&
    !firstGroupValidFieldsList.length &&
    !secondGroupValidConditions &&
    thirdGroupValidConditions;
  if (checkOne || checkTwo || checkThree) {
    return true;
  }

  return required;
}
